import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Services from '../pages/servicesgroup/drafting';
import Takeoff from '../pages/servicesgroup/takeoff';
import Programming from '../pages/servicesgroup/programming';
import ServiceDetail from '../pages/service-detail/page';
import Portfolio from '../pages/portfolio/page';
import About from '../pages/about/page';
import NotFound from '../pages/NotFound';
import ContactPage from '../pages/contact/page';
import ProcessPage from '../pages/process/page';
import BlogsPage from '../pages/blogs/page';
import BlogDetailPage from '../pages/blog-detail/page';
import SkillsPage from '../pages/skills/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/drafting',
    element: <Services />,
  },
  {
    path: '/services/takeoff',
    element: <Takeoff />,
  },
  {
    path: '/services/programming',
    element: <Programming />,
  },
  {
    path: '/process',
    element: <ProcessPage />,
  },
  {
    path: '/service/:serviceName',
    element: <ServiceDetail />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blogs',
    element: <BlogsPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/skills-and-capability-assessment',
    element: <SkillsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
